import {useEffect, useRef} from 'react';

import SocketManager from './service';

export function useSocket(condition: boolean) {
  const socketManager = useRef(SocketManager.getInstance());

  useEffect(() => {
    if (!condition) return;

    const socketInstance = socketManager.current;
    if (socketInstance) socketInstance.connect();

    return () => {
      socketInstance.disconnect();
    };
  }, [condition]);

  return socketManager.current;
}
